export default __webpack_public_path__ + "static/media/modern01.48629e82.jpg";